module.exports = __webpack_public_path__ + "img/mz.61f6944.svg";